import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            user: '',pass: ''
        };
        this.handleUserChange = this.handleUserChange.bind(this);
        this.handlePassChange = this.handlePassChange.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(event) {
        this.setState({value: event.target.value});
    }
    handleUserChange(event) {
        this.setState({user: event.target.value});
    }
    handlePassChange(event) {
        this.setState({pass: event.target.value});
    }
    handleSubmit(event) {
        var alertText = 'unsuccessful try again'
        if(this.state.user == 'admin' && this.state.pass == 'pass2' ){
            alertText = 'Login successful'
            window.location.assign('#/patients')
        }
        alert(alertText);
        event.preventDefault();

    }




  render() {
      return <div id="content">
          <div class="pt100 bg-grad-mojito">

              <div class="container">
                  <div class="row">

                      <div class="col-md-12 pt50 text-center">
                          <h1 class="brand-heading font-montserrat text-uppercase color-light">Login</h1>
                      </div>
                      <div class="col-md-6 col-md-offset-3 text-center">
                          <form onSubmit={this.handleSubmit}>
                              <input type="text" name="username"onChange = {this.handleUserChange} class="form-control input-circle input-lg no-border text-left" placeholder="Username"/>
                              <input type="password" name="password"onChange = {this.handlePassChange} class="form-control input-circle input-lg no-border text-left" placeholder="Password"/>
                              <input type="submit" value="Login" />
                          </form>
                      </div>
                  </div>
                  <hr />

              </div>
          </div>


      </div>

  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js